import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IVivaApiSecretField {
	settingsId: string;
	onChange: (value: string) => void;
}

const VivaApiSecretField: React.FC<IVivaApiSecretField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAPISecret') }], [t]);

	return (
		<FormInput
			testId="VivaApiSecretField"
			name={`vivaApiSecret-${settingsId}`}
			label="APISecretLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(VivaApiSecretField);
